import Repository from '@/repositories/base/Repository';
import IContactSupportParams from '@/repositories/parameters/IContactSupportParams';

export default class ContactSupportRepository extends Repository {
  async getCompanyBySearch(params: IContactSupportParams): Promise<void> {
    await this.datasource.send('contact-support', params);
  }
}
